/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import './Description.css'

import voiceConditioningProduct from 'assets/img/mockups/listen-first-ipad.png';
import voiceConditioningProduct2 from 'assets/img/mockups/vc-banner-nobg2.png';


// reactstrap components
import {
  Badge,  
  Container,
  Row,
  Col,

} from "reactstrap";

class Description extends React.Component {

  render() {
    return (
      <>
        <section className="section section-lg product-description-section">
          <Container>
            <Row className="row-grid align-items-center">
              <Col className="order-md-1 vc-product-1" md="6">
                <div className="blob"></div>
                  <img
                      alt="..."
                      className="img-fluid product-img-1 "
                      src={voiceConditioningProduct}
                    />

              </Col>
              <Col className="order-md-2" md="6">
                <div className="pr-md-5">
                  
                  <h2>What is Listen First?</h2>
                  <p>
                    Listen First is a scientifically researched protocol designed by educators and 
                    researchers to assist individuals with verbal developmental delays in attending 
                    to human voices. This innovative approach serves as the foundation for building 
                    and enhancing verbal communication skills, marking the first step in a transformative 
                    journey toward language development.
                  </p>
                  <ul className="list-unstyled mt-5 ">
                    <li className="py-2">
                      <div className="d-flex align-items-center align-top-bullet">
                        <div>
                          <Badge
                            className="badge-circle mr-3"
                            color="primary"
                          >
                            <i className="ni ni-check-bold" />
                          </Badge>
                        </div>
                        Developed by the renowned Fred S. Keller Institution, 
                        Listen First is rooted in rigorous scientific research.
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center align-top-bullet">
                        <div>
                          <Badge
                            className="badge-circle mr-3"
                            color="primary"
                          >
                            <i className="ni ni-check-bold" />
                          </Badge>
                        </div>
                          This app provides educators and therapists with a proven, research-based teaching 
                          protocol, offering a clear and structured step-by-step approach to 
                          support effective learning and development.
                      </div>
                    </li>
                    <li className="py-2">
                      <div className="d-flex align-items-center align-top-bullet">
                        <div>
                          <Badge
                            className="badge-circle mr-3"
                            color="primary"
                          >
                            <i className="ni ni-check-bold" />
                          </Badge>
                        </div>
                        <div>
                          This app makes these proven methods readily available, providing a consistent and 
                          effective  development for individuals with developmental delays.
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </Col>

              
            </Row>


            <Row className="row-grid align-items-center">

              <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    
                    <h2>How does it work?</h2>
                    <p>
                      Listen First was specifically designed to transform the human voice into a 
                      reinforcing stimulus for individuals who do not naturally attend to it. 
                      The app features a structured teaching protocol, which includes a training phase 
                      and five intervention phases. During the training phase, individuals learn to use the 
                      device correctly. In the intervention phases, a carefully designed gradient of 
                      stimuli—starting with music, progressing to sung stories, and finally to narrated 
                      stories—gradually captures the individual’s interest, effectively selecting their behavior. 
                      By the end of the protocol, the goal is for individuals to consistently attend to and engage 
                      with human voices.
                    </p>
                    
                  </div>
                </Col>



                <Col className="order-md-2 vc-product-1" md="6">
                  <div className="blob-2"></div>
                    <img
                        alt="..."
                        className="img-fluid product-img-1 "
                        src={voiceConditioningProduct2}
                      />



                </Col>
            </Row>

          </Container>
        </section>

      </>
    )
  }
}

export default Description;